<template>
	<fieldset class="guestrooms_fieldset">
		<legend>{{ language.guestRoomLegend }}</legend>

		<div class="form-row form-row--wide">
			<div class="form-field" v-click-outside="hideDropdown" @keydown=keyDownHandler>
				<a href="" class="hidden" id="guestModalToggle" data-target="#modal10" rel="nofollow"></a>
				<input type="hidden" name="guests" v-model="guests">
				<input type="hidden" name="rooms" v-model="rooms">
				<label for="guestrooms" id="bookingform__guestrooms__label">{{ language.rooms }} &amp; {{ language.people }}</label>
				<input name="guestrooms" id="guestrooms" ref="grInputField" :value="shortHandText" readonly @click="openDropdown" @keydown.enter.prevent="toggleDropdown" @keydown.space="openDropdown" @keyup.escape="hideDropdown" @focus="onFocus" :class="{'focus': dropDownOpen}">
				<div :class="dropDownOpen ? 'input-dropdown open' : 'input-dropdown'" v-if="dropDownOpen" ref="grDropDown">
          <div class="input-dropdown__segment input-dropdown__segment--plusminus">
            <div class="counter_text">
              {{ language.rooms }}
            </div>
            <div class="number_counter">
              <span class="minus" @click="setRooms(-1)" v-if="roomsChangeable[0]"></span>
              <span class="minus inaktive" v-if="!roomsChangeable[0]"></span>
              <input type="text" value="1" name="rooms" id="rooms" max="11" v-model="rooms" @keyup="changeRooms">
              <span class="plus" @click="setRooms(1)" v-if="roomsChangeable[1]"></span>
              <span class="plus inaktive" v-if="!roomsChangeable[1]"></span>
            </div>
          </div>
					<div class="input-dropdown__segment input-dropdown__segment--plusminus">
						<div class="counter_text">
							{{ language.people_bar }}
						</div>
						<div class="number_counter" data-max="2">
							<span class="minus" @click="setGuests(-1)" v-if="guestsChangeable[0]"></span>
							<span class="minus inaktive" v-if="!guestsChangeable[0]"></span>
							<input type="text" value="1" name="guests" max="11" v-model="guests" @keyup="changeGuests">
							<span class="plus" @click="setGuests(1)" v-if="guestsChangeable[1]"></span>
							<span class="plus inaktive" v-if="!guestsChangeable[1]"></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</fieldset>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
	name: 'GuestRooms',

	data: function(){
		return {
			dropDownOpen: false
		}
	},
	mounted: function (){
		this.roomsChangeable
		this.guestsChangeable
	},
	computed: {
		language: function() {
			return this.$store.state.language
		},

		citizenm: function(){
			return window.citizenm ? window.citizenm : { helpers: { show: function(){return}}}
		},

		shortHandText: function(){
			const guests = this.guests + ' ' + this.language.people_bar //(this.guests > 1 ? this.language.adults : this.language.adult)
      const rooms = this.rooms +  ' ' + this.language.rooms //(this.rooms > 1 ? this.language.rooms : this.language.room)
			return rooms + ' - ' + guests
		},

		rooms: {
			set(value) {
				this.$store.commit('setRooms', value)
			},
			get() {
				return this.$store.state.rooms
			}
		},
		roomsChangeable: function (){
			const stat = [true, true]

			if(this.$store.state.rooms == 1){
				stat[0] = false
			}
			if(this.$store.state.rooms > this.$store.state.roomsMax) {
				//stat[1] = false
				this.setRooms(-1)
			}

			return stat
		},
		guestsChangeable: {
			set(){
				return this.get
			},
			get(){
				const stat = [true, true]

				if (this.$store.state.guests == 1) {
					stat[0] = false
				}
				if (this.$store.state.guests >= this.$store.state.guestsMax) {
					stat[1] = false
				}

				return stat
			}
		},
		guests: {
			set(value) {
				this.$store.commit('setGuests', Math.min(parseInt(value), this.$store.state.guestsMax))
			},
			get() {
				return this.$store.state.guests
			}
		}
	},

	methods: {

		onFocus() {
			this.$emit('focus')
		},

		toggleDropdown() {
			if(this.dropDownOpen) return this.hideDropdown()
			return this.openDropdown()
		},
		openDropdown() {
			this.dropDownOpen = true
			this.$emit('opened')
		},
		hideDropdown() {
			this.dropDownOpen = false
			this.$emit('closed')
		},

		close: function(){
			return this.hideDropdown()
		},

		setRooms: function (diff) {
			const newRooms = this.$store.state.rooms + parseInt(diff)
			this.$store.commit('setRooms', Math.min(newRooms, this.$store.state.roomsMax))

			if(newRooms > this.$store.state.roomsMax){
				// open modal
				const evt = new MouseEvent('click', {
					bubbles: true,
					cancelable: true,
					view: window
				})
				document.getElementById('guestModalToggle').dispatchEvent(evt)
			}
			this.roomsChangeable
			this.$emit('update')
		},
		changeRooms: function(e){
			switch(e.key) {
				//case 'ArrowUp':
				case 'ArrowRight':
					if(this.roomsChangeable[1]) this.setRooms(1)
					break
				//case 'ArrowDown':
				case 'ArrowLeft':
					if(this.roomsChangeable[0]) this.setRooms(-1)
					break
				default:
					break
			}
		},

		setGuests: function (diff) {
			const newGuests = this.$store.state.guests + parseInt(diff)
			this.$store.commit('setGuests', Math.min(newGuests, this.$store.state.guestsMax))
			this.guestsChangeable
			this.$emit('update')
		},

		addGuest: function () {

		},
		removeGuest: function() {

		},

		changeGuests: function(e){
			switch(e.key) {
				// case 'ArrowUp':
				case 'ArrowRight':
					if(this.guestsChangeable[1]) this.setGuests(1)
					break
				// case 'ArrowDown':
				case 'ArrowLeft':
					if(this.guestsChangeable[0]) this.setGuests(-1)
					break
				default:
					break
			}
		},

    keyDownHandler(e){
      if(e.key == 'Tab'){
        this.hideDropdown();
      }
      else if(e.key == 'Escape'){
        this.$refs.inputField.focus()
      }
      else {
        if(e.key == 'ArrowDown'){
          // next
          this.focusNextItem(e)
        }
        if(e.key == 'ArrowUp'){
          // prev
          this.focusPrevItem(e)
        }
      }
    },

    focusNextItem(e){
      const eventTarget = e.target;
      let nextItem = eventTarget.parentNode.parentNode.nextElementSibling || eventTarget.parentNode.parentNode.previousElementSibling;

      // When key down happens in initial input field
      if(e.target === this.$refs.grInputField){
        this.openDropdown()
        nextItem = this.$refs.grDropDown;
      }

      // Select first a in nextItem
      if(nextItem) nextItem.querySelector('input').focus();
    },

    focusPrevItem(e){
      // When key down happens in initial input field do nothing
      if(e.target === this.$refs.grInputField) return;

      const eventTarget = e.target;
      let nextItem = eventTarget.parentNode.parentNode.previousElementSibling || eventTarget.parentNode.parentNode.nextElementSibling;

      // Select first a in nextItem
      if(nextItem) nextItem.querySelector('input').focus();
    },
	},

	// do not forget this section
	directives: {
		ClickOutside
	}
}
</script>